/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListAIToolVersionsPathParams = NonNullable<operations['listAIToolVersions']['parameters']['path']>;

export type ListAIToolVersionsQueryParams = NonNullable<operations['listAIToolVersions']['parameters']['query']>;

export interface Input extends ListAIToolVersionsPathParams {
  apiVersion?: string;
  query?: ListAIToolVersionsQueryParams;
}

export async function listAIToolVersions(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/ai-tools/{toolKey}/versions', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
